import BaseModel from "./BaseModel";
import Checkout from "./Checkout";

export default class CheckoutPayment extends BaseModel {
    static data_name = 'payment';

    static async create(checkout_document_id, stripe_token) {
        let instance = new this();
        instance.document_id = this.data_name;
        instance.parent = new Checkout();
        instance.parent.document_id = checkout_document_id;
        instance.parent_document_id = checkout_document_id;
        instance.stripe_token = stripe_token;
        instance.created_at = this.timestamp();

        console.log("checkout payment fb", instance.toFirebaseDocument())

        await instance.save();
        return instance;
    }

    static async forCheckout(checkout){
        let subcollection_document_id = this.data_name;
        return await this.getSubCollectionDocument(checkout, subcollection_document_id);
    }
}